var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 960,
    viewBox: "0 0 545 960",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M676.106 437.823C604.392 367.314 506.081 323.801 397.602 323.801C397.602 104.146 575.544 -73.9219 795.043 -73.9219C904.78 -73.9219 1004.13 -29.4142 1076.05 42.5394L1076.02 42.5705L1120.29 86.8762C1229.74 196.402 1230.08 373.867 1121.07 483.822C1011.44 594.383 832.902 594.731 722.852 484.599L676.106 437.823Z",
    fill: "#00C7D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M548.317 877.826L595.063 924.602C665.519 996.366 709.001 1094.75 709.001 1203.3C928.501 1203.3 1106.44 1025.23 1106.44 805.58C1106.44 695.768 1061.97 596.35 990.064 524.381L990.036 524.409L945.759 480.103C836.313 370.577 658.97 370.232 549.096 479.326H549.093C438.611 589.029 438.263 767.694 548.317 877.826Z",
    fill: "#FFBD00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.288 649.311L511.545 602.535C441.086 530.767 397.603 432.387 397.603 323.83C397.603 216.125 440.409 118.435 509.896 46.8196L509.921 46.7544L120.723 436.228L120.788 436.203C46.4015 508.479 0.161621 609.607 0.161621 721.553C0.161621 831.368 44.6378 930.783 116.541 1002.76L116.572 1002.73L160.846 1047.03C270.295 1156.56 447.634 1156.9 557.511 1047.81C667.994 938.107 668.342 759.443 558.288 649.311Z",
    fill: "#841DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBgRight);
export default __webpack_public_path__ + "static/media/home-bg-right.9479f11c.svg";
export { ForwardRef as ReactComponent };